import { render, staticRenderFns } from "./OBD.vue?vue&type=template&id=5b1814c8&scoped=true"
import script from "./OBD.vue?vue&type=script&lang=js"
export * from "./OBD.vue?vue&type=script&lang=js"
import style0 from "./OBD.vue?vue&type=style&index=0&id=5b1814c8&prod&lang=less&scoped=true"
import style1 from "./OBD.vue?vue&type=style&index=1&id=5b1814c8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b1814c8",
  null
  
)

export default component.exports